export const componentId = (rendering) => {
  if (rendering && rendering.uid) {
    return `i${rendering.uid.replace(/[{}]/g, "")}`;
  }
  return null;
};
